import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiGetAutoBidsParams,
  BackendErrorEntity,
  GetAutoBidsResponseDto,
  PlaceAutoBidBodyDto,
  PlaceAutoBidResponseDto,
  UpdateActiveAutoBidBodyDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetAutoBids = (
    params?: MaybeRef<ApiGetAutoBidsParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetAutoBidsResponseDto>(
      {url: `/autoBids`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetAutoBidsQueryKey = (params?: MaybeRef<ApiGetAutoBidsParams>,) => {
    return ['autoBids', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetAutoBidsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetAutoBids>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetAutoBidsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetAutoBids>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetAutoBidsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetAutoBids>>> = () => apiGetAutoBids(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetAutoBids>>, TError, TData> 
}

export type ApiGetAutoBidsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetAutoBids>>>
export type ApiGetAutoBidsQueryError = ErrorType<BackendErrorEntity>



export function useApiGetAutoBids<TData = Awaited<ReturnType<typeof apiGetAutoBids>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetAutoBidsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetAutoBids>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetAutoBidsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiPlaceAutoBid = (
    placeAutoBidBodyDto: MaybeRef<PlaceAutoBidBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      placeAutoBidBodyDto = unref(placeAutoBidBodyDto);
      
      return fetchApiInstance<PlaceAutoBidResponseDto>(
      {url: `/autoBids`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: placeAutoBidBodyDto
    },
      options);
    }
  


export const getApiPlaceAutoBidMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPlaceAutoBid>>, TError,{data: BodyType<PlaceAutoBidBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPlaceAutoBid>>, TError,{data: BodyType<PlaceAutoBidBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPlaceAutoBid>>, {data: BodyType<PlaceAutoBidBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiPlaceAutoBid(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPlaceAutoBidMutationResult = NonNullable<Awaited<ReturnType<typeof apiPlaceAutoBid>>>
    export type ApiPlaceAutoBidMutationBody = BodyType<PlaceAutoBidBodyDto>
    export type ApiPlaceAutoBidMutationError = ErrorType<BackendErrorEntity>

    export const useApiPlaceAutoBid = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPlaceAutoBid>>, TError,{data: BodyType<PlaceAutoBidBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPlaceAutoBid>>,
        TError,
        {data: BodyType<PlaceAutoBidBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiPlaceAutoBidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUpdateActiveAutoBid = (
    id: MaybeRef<string | undefined | null>,
    updateActiveAutoBidBodyDto: MaybeRef<UpdateActiveAutoBidBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
updateActiveAutoBidBodyDto = unref(updateActiveAutoBidBodyDto);
      
      return fetchApiInstance<PlaceAutoBidResponseDto>(
      {url: `/autoBids/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateActiveAutoBidBodyDto
    },
      options);
    }
  


export const getApiUpdateActiveAutoBidMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateActiveAutoBid>>, TError,{id: string;data: BodyType<UpdateActiveAutoBidBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateActiveAutoBid>>, TError,{id: string;data: BodyType<UpdateActiveAutoBidBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateActiveAutoBid>>, {id: string;data: BodyType<UpdateActiveAutoBidBodyDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiUpdateActiveAutoBid(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateActiveAutoBidMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateActiveAutoBid>>>
    export type ApiUpdateActiveAutoBidMutationBody = BodyType<UpdateActiveAutoBidBodyDto>
    export type ApiUpdateActiveAutoBidMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateActiveAutoBid = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateActiveAutoBid>>, TError,{id: string;data: BodyType<UpdateActiveAutoBidBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateActiveAutoBid>>,
        TError,
        {id: string;data: BodyType<UpdateActiveAutoBidBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateActiveAutoBidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    